import { render, staticRenderFns } from "./StatsPayoutPlan.vue?vue&type=template&id=6501dca2&"
import script from "./StatsPayoutPlan.vue?vue&type=script&lang=js&"
export * from "./StatsPayoutPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports